import React from 'react';

import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';

interface IEventReceiverFormFooter {
    disabled?: boolean;
    onDismiss: () => void;
    onSubmit: () => void;
}

const EventReceiverFormFooter: React.FunctionComponent<IEventReceiverFormFooter> = ({ disabled, onDismiss, onSubmit }) => (
    <div className="eventReceiver-form-footer-container">
        <PrimaryButton type="submit" disabled={disabled} onClick={onSubmit} styles={{ root: { marginRight: 10 } }}>
            Salva
        </PrimaryButton>

        <DefaultButton disabled={disabled} onClick={onDismiss}>
            Annulla
        </DefaultButton>
    </div>
);

export default EventReceiverFormFooter;